import { render } from "./edit.vue?vue&type=template&id=1506db79&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=1506db79&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1506db79"],['__file',"src/views/alfmeier/quest/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1506db79"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1506db79', __exports__)) {
    console.log('reload')
    api.reload('1506db79', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=1506db79&scoped=true", () => {
    console.log('re-render')
    api.rerender('1506db79', render)
  })

}


export default __exports__